import React from "react";
import { REGISTER_URL, WHATSAPP_URL, WHATSAPP_DISPLAY, COHORT_INFO } from "@/lib/site";
import { ArrowRight, MessageCircle } from "lucide-react";

export default function FinalCTA() {
    return (
        <section
            id="register"
            data-testid="final-cta-section"
            className="py-24 md:py-32 bg-[color:var(--navy)] text-white relative overflow-hidden"
        >
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 15% 30%, rgba(122,31,47,0.4), transparent 45%), radial-gradient(circle at 85% 70%, rgba(181,138,43,0.22), transparent 42%)",
                }}
            />
            <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <div className="font-mono-label text-[color:var(--gold-soft)]">
                    Final Call
                </div>
                <h2
                    className="mt-4 font-serif text-4xl sm:text-6xl leading-[1.05] tracking-tight"
                    style={{ fontWeight: 500 }}
                >
                    Ready to Move
                    <span className="block italic text-white/75">from Confusion to Clarity?</span>
                </h2>
                <div className="hr-gold mt-6 mx-auto" />
                <p className="mt-6 text-white/70 max-w-2xl mx-auto leading-relaxed">
                    Join the Qualitative Research Success Series and learn how to design, conduct,
                    analyse, write and publish qualitative research with greater confidence.
                </p>

                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3.5">
                    <a
                        href={REGISTER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-register-btn"
                        className="group inline-flex items-center justify-center gap-2 rounded-full bg-[color:var(--gold)] text-[color:var(--navy)] px-8 py-4 text-sm font-semibold hover:bg-[color:var(--gold-soft)] transition-colors"
                    >
                        Register for Next Cohort
                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                    </a>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-whatsapp-btn"
                        className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 text-sm font-semibold text-white hover:bg-white/5 transition-colors"
                    >
                        <MessageCircle className="h-4 w-4" />
                        WhatsApp Us
                    </a>
                </div>

                <div className="mt-8 space-y-1 text-xs text-white/60">
                    <p data-testid="final-current-cohort">
                        Current cohort: {COHORT_INFO.cohortLabel}, {COHORT_INFO.cohortMonth}
                    </p>
                    <p>
                        {COHORT_INFO.frequency}, {COHORT_INFO.time}, {COHORT_INFO.timezone}
                    </p>
                    <p className="text-white/45 mt-2">
                        WhatsApp: {WHATSAPP_DISPLAY} · Registration is handled through the official Google Form.
                    </p>
                </div>
            </div>
        </section>
    );
}
